module.exports = __webpack_public_path__ + "img/03_Paddy_Productivity_I_s.b1e65eb7.png";